exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-thankyou .text {\n  color: #838383;\n  font-size: 14px; }\n\n.page-thankyou .error {\n  color: #ff0000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/reset/reset.component.scss
// module id = ../../../../../src/app/pages/reset/reset.component.scss
// module chunks = main